<template>
  <!-- <div> -->
    <div id="hubFooter">
      <b-navbar class="row ">
        <!-- <b-navbar-brand class="col-2 alignVert"> -->
          <!-- <a href="https://www.artc.com.au/" target="_blank">
            <img src='img/companies/ARTC-logo.png' alt="..." height="30"/>
          </a> -->
          <!-- <div class="mt-1 mb-1">
            <img id="headerImage" src="img/ArcadisLogo.png">
          </div>
        </b-navbar-brand> -->
        <b-navbar-nav>
          <b-nav-item href="https://plenarygroup.com/" target="_blank"><b-img src='img/companies/PlenaryNew.png' alt="..." height="45" rounded/></b-img></b-nav-item>
          <b-nav-item href="https://www.webuildgroup.com/en" target="_blank"><b-img src='img/companies/WebuildNew.png' alt="..." height="45" rounded/></b-img></b-nav-item>
          <b-nav-item href="https://www.g-s.com.au/" target="_blank"><b-img src='img/companies/GSNew.png' alt="..." height="45" rounded/></b-img></b-nav-item>
          <b-nav-item href="https://www.cloughgroup.com/" target="_blank"><b-img src='img/companies/CloughNew.png' alt="..." height="45" rounded/></b-img></b-nav-item>
          <!-- <b-nav-item href="https://www.arcadis.com/en/australia/" target="_blank"><b-img src='img/companies/ArcadisNew.jpg' alt="..." height="45" rounded/></b-img></b-nav-item> -->
          <b-nav-item href="https://www.arcadis.com/en/australia/" target="_blank"><b-img src='img/companies/Arcadis_Logo_Colour.jpg' alt="..." height="20" rounded class="mt-2"/></b-img></b-nav-item>
          <b-nav-item href="https://www.ghd.com/en/index.aspx" target="_blank"><b-img src='img/companies/GHDNew.png' alt="..." height="45" rounded/></b-img></b-nav-item>
          <b-nav-item href="http://www.italferr.it/content/italferr/en/proejct-studies/oceania/australia.html" target="_blank"><b-img src='img/companies/italferr-logo.jpg' alt="..." height="45" rounded/></b-img></b-nav-item>
          <b-nav-item href="http://www.broadspectrum.com/" target="_blank"><b-img src='img/companies/Broadspectrum_logo2.png' alt="..." height="45" rounded/></b-img></b-nav-item>
        </b-navbar-nav>
      </b-navbar>
    </div>
</template>
<script>
export default {
  name: "HubFooter"
}
</script>
<style>
  #hubFooter {
    width: 100vw!important;
    height: 5.5vh!important;
    /* background-color: blue; */
    background: rgba(255, 255, 255, 0.18)
  }
  .alignVert {
    padding: 1vh;
  }
</style>
